import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Card, Button, Form } from "react-bootstrap";
import {
  resetErrorLoginAction,
  loginUsuarioAction,
} from "../../redux/actions/loginActions";

import Logo from "../Layout/Logo";

import "./style.css";

import Alert from "../Utilidades/Alert";

const LoginForm = ({ handlerLogin }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [recordar, setRecordar] = useState(false); //
  const formikRef = useRef(null);

  // Acceder al state del store
  const { loading, error, errorMessage } = useSelector((state) => state.login);

  const usuarioDefault = {
    usuario: usuario,
    contrasena: contrasena,
  };

  const loginSchema = Yup.object().shape({
    usuario: Yup.string()
      .email("Introduzca un Email válido")
      .required("Requerido"),
    contrasena: Yup.string().required("Requerido"),
  });

  // mandar llamar el action de participanteAction
  const loginUsuario = (credenciales) => {
    if (recordar) {
      localStorage.setItem("savedUsuario", credenciales.usuario);
      localStorage.setItem("savedContrasena", credenciales.contrasena);
    } else {
      localStorage.removeItem("savedUsuario");
      localStorage.removeItem("savedContrasena");
    }
    dispatch(loginUsuarioAction(credenciales, navigate));
  };

  // Se ejecuta al destruir el componente
  useEffect(() => {
    return () => {
      dispatch(resetErrorLoginAction());
    };
  }, [dispatch]);

  useEffect(() => {
    const savedUsuario = localStorage.getItem("savedUsuario");
    const savedContrasena = localStorage.getItem("savedContrasena");

    if (savedUsuario && savedContrasena) {
      setUsuario(savedUsuario);
      setContrasena(savedContrasena);
      setRecordar(true); // activa el checkbox si había datos guardados
    }
  }, []);

  return (
    <div
      className="hold-transition login-page login-page-background"
    >
      <Card className="login-box">
        <Card.Header
          style={{ backgroundColor: "transparent", borderBottom: "none" }}
        >
          <Logo className="mt-5 mb-3" style={{ maxWidth: "200px" }} />
        </Card.Header>
        <Card.Body>
          <Card.Text className="text-center">Panel de Entregas</Card.Text>
          <Formik
            innerRef={formikRef}
            initialValues={usuarioDefault}
            enableReinitialize 
            validationSchema={loginSchema}
            onSubmit={(values, actions) => {
              loginUsuario(values);
            }}
          >
            {({ errors, touched, handleChange }) => (
              <FormikForm>
                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">Usuario</Card.Text>
                  <Form.Control
                    id="usuario"
                    name="usuario"
                    type="email"
                    value={usuario}
                    onChange={(e) => {
                      handleChange(e);
                      setUsuario(e.target.value);
                    }}
                    placeholder="Ingrese Email"
                    isInvalid={touched.usuario && !!errors.usuario}
                    autoComplete="username"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.usuario}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">Contraseña</Card.Text>
                  <Form.Control
                    id="contrasena"
                    name="contrasena"
                    type="password"
                    value={contrasena}
                    onChange={(e) => {
                      handleChange(e);
                      setContrasena(e.target.value);
                    }}
                    placeholder="Ingrese contraseña"
                    isInvalid={touched.contrasena && !!errors.contrasena}
                    autoComplete="current-password"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.contrasena}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Check
                    type="checkbox"
                    label="Recordar usuario y contraseña"
                    checked={recordar}
                    onChange={(e) => setRecordar(e.target.checked)}
                  />
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
          <Link to={"/recordarcontrasena"}>Recuperar Contraseña</Link>
        </Card.Body>
        <Card.Footer
          style={{ backgroundColor: "transparent", borderTop: "none" }}
        >
          <Button
            variant="success"
            className="btn-sm"
            onClick={() => {
              formikRef.current?.submitForm();
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Ingresando...
              </>
            ) : (
              "Ingresar"
            )}
          </Button>
          {!loading && error && (
            <Alert variant={"danger"} message={errorMessage} />
          )}
        </Card.Footer>
      </Card>
    </div>
  );
};

export default LoginForm;
